<template>
	<div class="jobadd">
		<div class="jobadd-title">
			{{ type == 'edit' ? '岗位编辑' : '岗位新增' }}
		</div>
		<div class="jobadd-tab" v-if="type == 'add'">
			<span @click="changeType(item.type)" v-for="(item, index) in jobtypeList" :key="index"
				:class="{ 'tab-item-active': item.type == currentType }" class="jobadd-tab-item">{{ item.title }}</span>
		</div>
		<div class="jobadd-tab" v-if="type == 'edit'">
			<span v-for="(item, index) in jobtypeList" :key="index">
				<span @click="changeType(item.type)" v-if="item.type == currentType"
					class="jobadd-tab-item tab-item-active">
					<span>{{ item.title }}</span>
				</span>
			</span>
		</div>
		<el-form ref="formJob" :model="formJob" :rules="rules">
			<el-form-item prop="schoolId">
				<div class="jobadd-formitem">
					<span class="jobadd-formitem-label">校区</span>
					<el-select class="jobadd-formitem-val" placeholder="请选择招募校区" v-model="formJob.schoolId">
						<el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</div>
			</el-form-item>
			<el-form-item prop="name">
				<div class="jobadd-formitem">
					<span class="jobadd-formitem-label">岗位名称</span>
					<el-input placeholder="请输入岗位名称" class="jobadd-formitem-val" type="text" v-model="formJob.name">
					</el-input>
				</div>
			</el-form-item>
			<el-form-item prop="starTime" v-if="currentType == 'S_FIX' || currentType == 'C_FIX'">
				<div class="jobadd-formitem" v-if="currentType == 'S_FIX'">
					<span class="jobadd-formitem-label">岗位时间</span>
					<el-date-picker class="jobadd-formitem-val" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
						type="date" placeholder="请选择开始时间" :disabled="type === 'edit'" :class="{ 'bg': type == 'edit' }"
						v-model="formJob.starTime">
					</el-date-picker>
					<span style="margin: 0 10px;">至</span>
					<el-date-picker style="border-left: 1px solid #DCDFE6;" class="jobadd-formitem-val"
						:class="{ 'bg': type == 'edit' }" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
						placeholder="请选择结束时间" :disabled="type === 'edit'" v-model="formJob.endTime">
					</el-date-picker>
				</div>
				<div v-else class="jobadd-formitem">
					<span class="jobadd-formitem-label">岗位时间</span>
					<el-date-picker @change="startDateChange" class="jobadd-formitem-val" format="yyyy-MM-dd"
						:disabled="type === 'edit'" :class="{ 'bg': type == 'edit' }" value-format="yyyy-MM-dd"
						type="date" placeholder="请选择开始时间" v-model="formJob.starTime">
					</el-date-picker>
					<span style="margin: 0 10px;">至</span>
					<el-date-picker @change="endDateChange" style="border-left: 1px solid #DCDFE6;"
						:disabled="type === 'edit'" :class="{ 'bg': type == 'edit' }" class="jobadd-formitem-val"
						format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="请选择结束时间"
						v-model="formJob.endTime">
					</el-date-picker>
				</div>
			</el-form-item>
			<el-form-item prop="postTime" v-if="currentType !== 'S_FIX' && currentType !== 'C_FIX'">
				<div class="jobadd-formitem">
					<span class="jobadd-formitem-label">岗位时间</span>
					<el-input placeholder="请输入岗位时间" class="jobadd-formitem-val" type="text" v-model="formJob.postTime">
					</el-input>
				</div>
			</el-form-item>
			<div v-if="currentType == 'S_FIX' || currentType == 'C_FIX'">
				<span class="time-note">注：请正确输入岗位时间，发布之后无法再重新修改</span>
			</div>
			<el-form-item prop="address">
				<div class="jobadd-formitem">
					<span class="jobadd-formitem-label">岗位地址</span>
					<el-input placeholder="请输入岗位地址" class="jobadd-formitem-val" type="text" v-model="formJob.address">
					</el-input>
				</div>
			</el-form-item>
			<el-form-item prop="maxPeo">
				<div class="jobadd-formitem">
					<span class="jobadd-formitem-label">可报名人数</span>
					<el-input placeholder="请输入岗位可报名人数数量（限数字）" class="jobadd-formitem-val" type="text"
						v-model="formJob.maxPeo"></el-input>
				</div>
			</el-form-item>
			<el-form-item prop="admittedNum">
				<div class="jobadd-formitem">
					<span class="jobadd-formitem-label">在岗人数</span>
					<el-input placeholder="请输入岗位在岗人数数量（限数字）" class="jobadd-formitem-val" type="text"
						v-model="formJob.admittedNum"></el-input>
				</div>
			</el-form-item>
			
			<el-form-item prop="salary">
				<div class="jobadd-formitem">
					<span class="jobadd-formitem-label">总时薪</span>
					<el-input placeholder="请输入总时薪" class="jobadd-formitem-val" type="text" v-model="formJob.salary"
							@input="handleNumberInput('salary')" @blur="validateSalaryFields">
					</el-input>
				</div>
			</el-form-item>
			<template v-if="currentType !== 'SO_PART_TIME'">
				<el-form-item prop="leagueSalary">
					<div class="jobadd-formitem">
						<span class="jobadd-formitem-label">团委时薪</span>
						<el-input placeholder="请输入团委时薪" class="jobadd-formitem-val" type="text" v-model="formJob.leagueSalary"
							@input="handleNumberInput('leagueSalary')" @blur="validateSalaryFields">
						</el-input>
					</div>
				</el-form-item>
				<el-form-item prop="collegeSalary">
					<div class="jobadd-formitem">
						<span class="jobadd-formitem-label">学院时薪</span>
						<el-input placeholder="请输入学院时薪" class="jobadd-formitem-val" type="text" v-model="formJob.collegeSalary"
							@input="handleNumberInput('collegeSalary')" @blur="validateSalaryFields">
						</el-input>
					</div>
				</el-form-item>
				<el-form-item prop="monthMaxAmount">
					<div class="jobadd-formitem">
						<span class="jobadd-formitem-label">每月最大工资金额</span>
						<el-input placeholder="请输入每月最大工资金额" class="jobadd-formitem-val" type="text" v-model="formJob.monthMaxAmount">
						</el-input>
					</div>
				</el-form-item>
			</template>
			
			<el-form-item prop="contact" v-if="currentType !== 'SO_FIX_TUTOR' && currentType !== 'SO_PART_TIME'">
				<div class="jobadd-formitem">
					<span class="jobadd-formitem-label">联系人</span>
					<el-input placeholder="请输入联系人" class="jobadd-formitem-val" type="text" v-model="formJob.contact">
					</el-input>
				</div>
			</el-form-item>
			<el-form-item prop="contactPhone" v-if="currentType !== 'SO_FIX_TUTOR' && currentType !== 'SO_PART_TIME'">
				<div class="jobadd-formitem">
					<span class="jobadd-formitem-label">联系方式</span>
					<el-input placeholder="请输入手机号/微信号/qq号" class="jobadd-formitem-val" type="text"
						v-model="formJob.contactPhone"></el-input>
				</div>
			</el-form-item>
			<el-form-item prop="attrs">
				<div class="jobadd-detail">
					<div class="jobadd-detail-label">培训素材</div>
					<div class="jobadd-detail-val" style="padding: 20px;">
						<el-upload class="upload-demo" action="#" :file-list="fileList" :before-upload="beforeUpload"
							:before-remove="beforeRemove" :on-remove="handleRemove"
							accept=".pdf,.mp4,.avi,.mov,.flv,.wmv" :on-preview="handleFilePreview"
							:http-request="customUpload" :auto-upload="true" :on-exceed="handleExceed">
							<el-button size="small" type="primary">
								<i class="el-icon-upload"></i> 点击上传
							</el-button>
							<div class="el-upload__tip" slot="tip">
								支持PDF、MP4、AVI、MOV、FLV、WMV格式<br>
								视频最大100MB，PDF最大20MB
							</div>
						</el-upload>
					</div>
				</div>
			</el-form-item>
			<el-form-item prop="details">
				<div class="jobadd-detail">
					<div class="jobadd-detail-label">岗位详情</div>
					<el-input type="textarea" class="jobadd-detail-val" :autosize="{ minRows: 6, maxRows: 6 }"
						:placeholder="currentType === 'S_FIX' || currentType === 'S_TEMP' ? '请输入岗位详情，如岗位基本情况、必要提示等' : '请输入岗位详情，如岗位基本情况、必要提示、负责人姓名、负责人联系方式等'"
						v-model="formJob.details"></el-input>
				</div>
			</el-form-item>
			<el-form-item prop="postDuty" v-if="currentType == 'SO_FIX_TUTOR' || currentType == 'SO_PART_TIME'">
				<div class="jobadd-detail">
					<div class="jobadd-detail-label">岗位要求</div>
					<el-input type="textarea" class="jobadd-detail-val" :autosize="{ minRows: 6, maxRows: 6 }"
						placeholder="请输入岗位要求" v-model="formJob.postDuty"></el-input>
				</div>
			</el-form-item>
			<el-form-item prop="orgId" v-if="currentType == 'S_FIX' || currentType == 'S_TEMP'">
				<div class="jobadd-formitem">
					<span class="jobadd-formitem-label">所属部门</span>
					<el-select class="jobadd-formitem-val" placeholder="请选择所属部门" v-model="formJob.orgId">
						<el-option v-for="(item, index) in orgList" :key="index" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</div>
			</el-form-item>
		</el-form>
		<div class="jobadd-btn">
			<span @click="jobHandle('confirm', 'formJob')" class="jobadd-btn-confirm">{{ editId ? '确认修改' : '立即发布'
			}}</span>
			<span @click="jobHandle('cancel')" class="jobadd-btn-cancel">取消</span>
		</div>
	</div>
</template>

<script>
import storage from 'store';
import {
	uploadFile,
	addJob,
	getJobDetail,
	editJob,
	schoollistAllPc
} from '@/api/pc/index'
import {
	orgListAllPc
} from '@/api/pc/user'

export default {
	data() {
		const checkPostTime = (rule, value, callback) => {
			if (!this.formJob.starTime || !this.formJob.endTime) {
				callback(new Error("请选择岗位时间"));
			} else {
				if (this.currentType != 'C_FIX') {
					let start = new Date(this.formJob.starTime).getTime()
					let end = new Date(this.formJob.endTime).getTime()
					if (start >= end) {
						callback(new Error("开始时间必须早于结束时间"));
						return;
					}
				}
				callback();
			}
		};
		const checkMaxpeo = (rule, value, callback) => {
			if (!value) {
				callback(new Error("请输入可报名人数"));
			} else if (!(/(^[1-9]\d*$)/.test(value))) {
				callback(new Error("请输入正整数"));
			} else {
				callback();
			}
		}
		const checkAdmittedNum = (rule, value, callback) => {
			if (!value) {
				callback(new Error("请输入在岗人数"));
			} else if (!(/(^[1-9]\d*$)/.test(value))) {
				callback(new Error("请输入正整数"));
			} else {
				callback();
			}
		}
		const checkTrainingMaterials = (rule, value, callback) => {
				if (this.type === 'add' && (!this.fileList || this.fileList.length === 0)) {
					callback(new Error("请至少上传一个培训素材文件"));
				} else if (this.type === 'edit' && (!this.formJob.attrs || this.formJob.attrs.length === 0)) {
					callback(new Error("请至少上传一个培训素材文件"));
				} else {
					callback();
				}
			}
			const checkSalary = (rule, value, callback) => {
				if (!value) {
					callback(new Error("请输入总时薪"));
				} else if (!(/^\d+(\.\d+)?$/.test(value))) {
					callback(new Error("请输入数值或小数"));
				} else {
					callback();
				}
			}
			const checkLeagueSalary = (rule, value, callback) => {
				if (!value) {
					callback(new Error("请输入团委时薪"));
				} else if (!(/^\d+(\.\d+)?$/.test(value))) {
					callback(new Error("请输入数值或小数"));
				} else {
					let college = parseFloat(this.formJob.collegeSalary)
					let total = parseFloat(this.formJob.salary)
					if (!isNaN(college) && !isNaN(total) && parseFloat(value) + college > total) {
						callback(new Error("团委时薪与学院时薪之和不能超过总时薪"));
					} else {
						callback();
					}
				}
			}
			const checkCollegeSalary = (rule, value, callback) => {
				if (!value) {
					callback(new Error("请输入学院时薪"));
				} else if (!(/^\d+(\.\d+)?$/.test(value))) {
					callback(new Error("请输入数值或小数"));
				} else {
					let league = parseFloat(this.formJob.leagueSalary)
					let total = parseFloat(this.formJob.salary)
					if (!isNaN(league) && !isNaN(total) && parseFloat(value) + league > total) {
						callback(new Error("团委时薪与学院时薪之和不能超过总时薪"));
					} else {
						callback();
					}
				}
			}
			return {
			department: [
				{
					label: '部门1',
					value: '1'
				},
				{
					label: '部门2',
					value: '2'
				},
			],
			identityPc: "",
			currentType: undefined,
			jobtypeList: [],
			orgList: [],
			schoolList: [],
			fileList: [],
			formJob: {
				name: "",
				postType: 1,
				attrs: []  // 修改：从null改为空数组（存储多个文件对象）
			},
			type: 'add',
			editId: "",
			rules: {
				schoolId: [{
					required: true,
					message: '请选择招募校区',
					trigger: 'change'
				},],
				name: [{
					required: true,
					message: '请输入岗位名称',
					trigger: 'blur'
				},],
				starTime: [{
					required: true,
					validator: checkPostTime,
					trigger: 'blur'
				},],
				address: [{
					required: true,
					message: '请输入岗位地址',
					trigger: 'blur'
				},],
				postTime: [{
					required: true,
					message: '请输入岗位时间',
					trigger: 'blur'
				},],
				admittedNum: [{
					required: true,
					validator: checkAdmittedNum,
					trigger: 'blur'
				},],
				maxPeo: [{
					required: true,
					validator: checkMaxpeo,
					trigger: 'blur'
				},],
				salary: [{
					required: true,
					validator: checkSalary,
					trigger: ['blur', 'change']
				},],
				leagueSalary: [{
					required: true,
					validator: checkLeagueSalary,
					trigger: ['blur', 'change']
				},],
				collegeSalary: [{
					required: true,
					validator: checkCollegeSalary,
					trigger: ['blur', 'change']
				},],
				monthMaxAmount: [{
					required: true,
					message: '请输入每月最大工资金额',
					trigger: 'blur'
				},],
				contact: [{
					required: true,
					message: '请输入联系人',
					trigger: 'blur'
				},],
				contactPhone: [{
					required: true,
					message: '请输入手机号/微信号/qq号',
					trigger: 'blur'
				},],
				details: [{
					required: true,
					message: '请输入岗位详情',
					trigger: 'blur'
				},],
				postDuty: [{
					required: true,
					message: '请输入岗位要求',
					trigger: 'blur'
				},],
				orgId: [{
					required: true,
					message: "请选择所属部门",
					trigger: "blur"
				}],
				attrs: [{
					required: true,
					validator: checkTrainingMaterials,
					trigger: ['blur', 'change']
				}]
			},
		}
	},
	created() {
		if (this.$route.query.id) {
			this.editId = this.$route.query.id
			this.getJobData()
		}
		if (this.$route.query.type) {
			this.type = this.$route.query.type
		}
	},
	mounted() {
		this.identityPc = storage.get("identityPc")
		if (this.identityPc == "学院老师") {
			this.jobtypeList = [{
				type: "C_FIX",
				title: "学院固定"
			},]
			this.currentType = "C_FIX"
		} else if (this.identityPc == "干部") {
			this.jobtypeList = [{
				type: "S_FIX",
				title: "校内固定"
			},
			{
				type: "S_TEMP",
				title: "校内临时"
			},
			{
				type: "SO_FIX_TUTOR",
				title: "校外家教"
			},
			{
				type: "SO_PART_TIME",
				title: "校外兼职"
			},
			]
			this.currentType = "S_FIX"
		}
		this.formJob.postType = this.currentType
		this.getOrgList()
		this.getSchoolList()
	},
	methods: {
		getOrgList() {
			let params = {
				pageIndex: 1,
				pageSize: 999
			}
			orgListAllPc(params).then((res) => {
				if (res.code == 0) {
					this.orgList = res.data
				}
			})
		},
		getSchoolList() {
			let params = {
				pageIndex: 1,
				pageSize: 999
			}
			schoollistAllPc(params).then((res) => {
				if (res.code == 0) {
					this.schoolList = res.data
				}
			})
		},
		startDateChange(e) {
			if (e) {
				this.formJob.starTime = e
			} else {
				this.formJob.starTime = ""
			}
		},
		endDateChange(e) {
				if (e) {
					this.formJob.starTime = e
				} else {
					this.formJob.starTime = ""
				}
			},
			handleNumberInput(field) {
				let value = this.formJob[field]
				if (value !== undefined && value !== null && value !== '') {
					value = value.toString().replace(/[^\d.]/g, '')
					let parts = value.split('.')
					if (parts.length > 2) {
						value = parts[0] + '.' + parts.slice(1).join('')
					}
					this.$set(this.formJob, field, value)
				}
			},
			validateSalaryFields() {
				this.$refs.formJob.validateField('salary')
				this.$refs.formJob.validateField('leagueSalary')
				this.$refs.formJob.validateField('collegeSalary')
			},
		getJobData() {
			getJobDetail(this.editId).then(res => {
				if (res.code == 0) {
					this.formJob = res.data
					this.currentType = res.data.postType
					if (!Array.isArray(this.formJob.attrs)) {
						this.formJob.attrs = this.formJob.attrs ? [this.formJob.attrs] : []
					}
					this.fileList = this.formJob.attrs.map((file, index) => {
						return {
							uid: file.uid || `edit-file-${Date.now()}-${index}`, // 唯一标识：优先用后端返回，无则生成（时间戳+索引避免重复）
							name: file.name || '未命名文件', // 文件名回显
							url: file.url, // 文件预览地址（必选，用于预览和删除逻辑）
							raw: null // 补充raw字段（组件内部可能依赖，编辑场景下可设为null）
						}
					})
				}
			})
		},
		changeType(type) {
			this.formJob = {
				postType: type,
				attrs: []
			}
			this.currentType = type
			this.fileList = []
			this.$refs.formJob.resetFields();
		},
		handleExceed(files, fileList) {
			const maxCount = 5;
			if (fileList.length + files.length > maxCount) {
				this.$message.warning(`最多只能上传${maxCount}个培训素材文件，请先删除已上传的文件后再试`);
				return false;
			}
		},
		jobHandle(type, formJob) {
			switch (type) {
				case "confirm":
					this.handleAddJob(formJob)
					break;
				case "cancel":
					this.$router.go(-1)
					break;
			}
		},
		handleAddJob(formJob) {
			this.$refs[formJob].validate((valid) => {
				if (valid) {
					// 统一处理：新增/编辑场景都同步fileList到formJob.attrs
					if (this.fileList.length > 0) {
						this.formJob.attrs = this.fileList.map(file => ({
							name: file.name,
							url: file.url,
							uid: file.uid // 可选，根据后端接口需求决定是否传递
						}))
					} else {
						this.formJob.attrs = []; // 无文件时置为空数组，避免提交null
					}

					// 后续的editJob/addJob逻辑不变...
					if (this.editId) {
						editJob(this.formJob, this.editId).then(res => {
							if (res.code == 0) {
								this.$message.success('修改成功')
								this.$router.go(-1)
							} else {
								this.$message.error('修改失败：' + res.msg)
							}
						})
					} else {
						addJob(this.formJob).then(res => {
							if (res.code == 0) {
								this.$message.success('发布成功')
								this.$router.go(-1)
							} else {
								this.$message.error('发布失败：' + res.msg)
							}
						})
					}
				} else {
					this.$message.warning('请完善表单信息')
				}
			});
		},
		beforeUpload(file) {
			const isPDF = file.type === 'application/pdf' || file.name.endsWith('.pdf')
			const isVideo = ['video/mp4', 'video/avi', 'video/quicktime', 'video/x-flv', 'video/x-ms-wmv'].includes(file.type) ||
				['.mp4', '.avi', '.mov', '.flv', '.wmv'].some(suffix => file.name.endsWith(suffix))

			if (!isPDF && !isVideo) {
				this.$message.error('请上传PDF或视频文件（MP4/AVI/MOV/FLV/WMV）')
				return false
			}
			const isLt20M = isPDF && file.size / 1024 / 1024 < 20
			const isLt100M = isVideo && file.size / 1024 / 1024 < 100

			if (isPDF && !isLt20M) {
				this.$message.error('PDF文件大小不能超过20MB')
				return false
			}
			if (isVideo && !isLt100M) {
				this.$message.error('视频文件大小不能超过100MB')
				return false
			}
			return true
		},
		beforeRemove(file, fileList) {
			return new Promise((resolve, reject) => {
				this.$confirm(`确定要删除文件 ${file.name} 吗？`, '提示', {
					type: 'warning'
				}).then(() => {
					resolve(true);
				}).catch(() => {
					this.$message.info('已取消删除');
					reject(false);
				});
			});
		},

		handleRemove(file, fileList) {
			this.fileList = fileList;

			// 编辑场景：同步更新formJob.attrs（与当前文件列表保持一致）
			if (this.type === 'edit') {
				this.formJob.attrs = fileList.map(item => ({
					name: item.name,
					url: item.url,
					uid: item.uid
				}));
			}
		},
		handleFilePreview(file) {
			const fileUrl = file.url
			if (fileUrl) {
				window.open(fileUrl, '_blank');
			} else {
				this.$message.warning('文件预览地址不存在');
			}
		},
		async customUpload(params) {
			const { file, onSuccess, onError } = params;
			try {
				const formData = new FormData();
				formData.append('file', file);
				const res = await uploadFile(formData);
				if (res.code === 0) {
					const fileInfo = {
						uid: res.data.uuid, // 关键：添加uid，使用上传文件自身的唯一标识
						name: res.data.fileName,
						url: res.data.accessUrl,
						raw: file, // 补充raw字段，保持文件对象结构完整，兼容el-upload内部逻辑
					};
					onSuccess(res);
					this.fileList.push(fileInfo); // 推送完整结构的文件对象
					this.$message.success(`${file.name} 上传成功`);
				} else {
					onError(res.msg);
					this.$message.error(`${file.name} 上传失败：${res.msg}`);
				}
			} catch (err) {
				onError(err);
				this.$message.error(`${file.name} 上传异常，请重试`);
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.gray_bg {
	border-color: #F5F7FA;
	border-color: #E4E7ED;
	color: #C0C4CC;
}

/deep/.el-input__inner {
	height: 30px;
	border-color: #DCDFE6;
	border-radius: 0px 2px 2px 0px;
	border-left: 0;
}

/deep/.el-form-item {
	margin-bottom: 0;
}

/deep/.el-input__inner {
	border: 0;
	line-height: 40px;
	font-size: 14px;
}

/deep/.el-textarea__inner {
	border: 0;
	resize: none;
}

/deep/.el-select .el-input .el-select__caret {
	font-size: 14px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.bg {
	background: #F5F7FA;
}

.jobadd {
	display: flex;
	flex-direction: column;
	padding-bottom: 16px;

	.jobadd-title {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: bold;
		line-height: 22px;
		color: #303133;
		margin-top: 16px;
		margin-bottom: 16px;
		padding-left: 10px;
		border-left: 4px solid #4392FA;
	}

	.jobadd-tab {
		display: flex;

		.jobadd-tab-item {
			width: 120px;
			line-height: 36px;
			border: 1px solid #DCDFE6;
			border-radius: 2px;
			display: inline-block;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 14px;
			font-family: PingFang SC;
			font-weight: 400;
			color: #606266;
			cursor: pointer;
			margin-right: 16px;
		}

		.tab-item-active {
			background: rgba(67, 146, 250, 0.1000);
			border: 1px solid #4392FA;
			color: #4392FA;
		}
	}

	.jobadd-formitem {
		display: flex;
		// align-items: flex-start;
		align-items: center;
		margin-top: 16px;

		.jobadd-formitem-label {
			min-width: 140px;
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 0 22px;
			box-sizing: border-box;
			font-size: 14px;
			font-family: PingFang SC;
			font-weight: 400;
			color: #606266;
			border-radius: 2px 0px 0px 2px;
			background: #F6F7F9;
			border: 1px solid #DCDFE6;
			line-height: 38px;
			box-sizing: border-box;
			height: 40px;
		}

		.jobadd-formitem-val {
			flex: 1;
			height: 40px;
			line-height: 40px;
			border: 0;
			outline: none;
			box-sizing: border-box;
			font-size: 14px;
			font-family: PingFang SC;
			font-weight: 400;
			color: #606266;
			border: 1px solid #DCDFE6;
			border-radius: 0px 2px 2px 0px;
			border-left: 0;
			padding: 0 10px;
		}

		.jobadd-formitem-date {
			flex: 1;
		}

	}

	.jobadd-upload-container {
		flex: 1;
		border: 1px solid #DCDFE6;
		border-radius: 0px 2px 2px 0px;
		border-left: 0;
		padding: 16px;
		min-height: 40px;
		box-sizing: border-box;
	}





	.file-link:hover {
		text-decoration: underline;
	}

	/deep/.el-upload--text {
		text-align: left;
	}

	/deep/.el-upload__tip {
		margin-top: 8px;
		line-height: 1.4;
		font-size: 12px;
		color: #909399;
	}

	/deep/.el-upload-list__item {
		margin-top: 8px;
		border: 1px solid #e4e7ed;
		border-radius: 4px;
	}

	/deep/.el-upload-list__item-name {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	/deep/.el-upload-list__item-status-label {
		line-height: 32px;
	}

	/deep/.el-upload-list__item-actions {
		line-height: 32px;
	}
	/deep/ .el-input__icon{
		line-height: 40px !important;
	}
	.time-note {
		color: #909399;
		font-size: 12px;
	}

	.jobadd-detail {
		display: flex;
		flex-direction: column;

		.jobadd-detail-label {
			font-size: 14px;
			font-family: PingFang SC;
			font-weight: 400;
			line-height: 40px;
			color: #606266;
			background: #F6F7F9;
			border: 1px solid #DCDFE6;
			border-radius: 2px 2px 0px 0px;
			margin-top: 16px;
			padding: 0 22px;
			box-sizing: border-box;
		}

		.jobadd-detail-val {
			border: 1px solid #DCDFE6;
			border-radius: 0px 0px 2px 2px;
			resize: none;
			border-top: 0;
			font-size: 14px;
			font-family: PingFang SC;
			font-weight: 400;
			color: #606266;
			box-sizing: border-box;
		}
	}

	.jobadd-btn {
		display: flex;
		align-items: center;
		margin-top: 32px;

		.jobadd-btn-confirm {
			width: 96px;
			height: 36px;
			background: #4392FA;
			border-radius: 2px;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 14px;
			font-family: PingFang SC;
			font-weight: 400;
			color: #FFFFFF;
			cursor: pointer;
			margin-right: 16px;
		}

		.jobadd-btn-cancel {
			width: 96px;
			height: 36px;
			border-radius: 2px;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 14px;
			font-weight: 400;
			color: #303133;
			cursor: pointer;
			border: 1px solid #DCDFE6;
		}
	}
}
</style>